import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPasswordStars: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="password-stars"><path d="M1 17.25L23 17.25" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9.99944H15M13.5 12.5975L10.5 7.40137M10.5 12.5976L13.5 7.40144" stroke="currentColor" strokeWidth="1.5"/><path d="M17 9.99944H23M21.5 12.5975L18.5 7.40137M18.5 12.5976L21.5 7.40144" stroke="currentColor" strokeWidth="1.5"/><path d="M1 9.99944H7M5.5 12.5975L2.5 7.40137M2.5 12.5976L5.5 7.40144" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPasswordStars;
